'use client';

import { LikeIcon } from 'components/like-icon';
import { useTranslations } from 'next-intl';

export function CommentLikeButton({
  liked,
  likes,
  pending,
  onClick,
}: {
  liked: boolean;
  likes: number;
  pending: boolean;
  onClick: () => void;
}) {
  const t = useTranslations('Blog.Comments');
  return (
    <button
      type="button"
      aria-label={t('Like')}
      aria-pressed={liked}
      disabled={pending}
      className="inline-flex items-center gap-1.5 rounded py-1 transition-colors duration-150 hover:text-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500 motion-reduce:transition-none"
      onClick={onClick}
    >
      <LikeIcon isLiked={liked} className="size-3.5" />
      {likes > 0 && <span className="tabular-nums">{likes}</span>}
      <span>{t('Like')}</span>
    </button>
  );
}
